import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./ui/Header";
import Footer from "./ui/Footer";
import HeroIllustration from "images/promo/hero-illustration.svg";

export interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {

  useEffect(() => {
    AOS.init({
      once: true,
      duration: 600,
      easing: "ease-out-sine"
    });
  });

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Header />

      <main className="grow">
        <section className="relative">

          {/* Illustration */}
          <div className="hidden md:block absolute left-1/2 -translate-x-1/2 pointer-events-none"
               aria-hidden="true"
          >
            <HeroIllustration className="max-w-none"
                              width="1440"
                              height="1265"
            />
          </div>

          {children}

        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
